import { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { toast } from 'react-toastify';
import { createProjectMeetingNoteTypes, getProjectMeetingNoteTypes } from '../api/meetingNotes';

export const MeetingNoteTypes = ({
  onChange,
  defaultValue,
  onCreate,
  token,
  onRefresh,
}: {
  onChange: (value: any) => void;
  onCreate: (value: any) => void;
  defaultValue: string;
  token: string | undefined;
  project_id: string;
  onRefresh?: number;
}) => {
  const [isTypeLoading, setIsTypeLoading] = useState(false);
  const [typesOptions, setTypesOptions] = useState<any[]>([]);

  const loadMeetingTypes = async () => {
    if (!token) return;
    
    try {
      const data = await getProjectMeetingNoteTypes(token);
      setTypesOptions(data.results.map((p) => ({ label: p.name, value: p.id })));
    } catch (error) {
      console.error('Failed to load meeting types:', error);
    }
  };

  useEffect(() => {
    loadMeetingTypes();
  }, [token, onRefresh]);

  const createTypeOption = (id: string, label: string) => ({
    label,
    value: id,
  });

  const handleCreateType = async (inputValue: string) => {
    setIsTypeLoading(true);
    const id = crypto.randomUUID();
    try {
      const res = await createProjectMeetingNoteTypes(token || '', {
        id,
        name: inputValue,
      });

      const newOption = createTypeOption(res.id, inputValue);
      setTypesOptions((prev) => [...prev, newOption]);
      onCreate(res.id);
    } catch (error) {
      toast.error('Failed to create meeting note type');
    }
    setIsTypeLoading(false);
  };

  return (
    <CreatableSelect
      isClearable
      isDisabled={isTypeLoading}
      isLoading={isTypeLoading}
      onChange={onChange}
      onCreateOption={handleCreateType}
      options={typesOptions}
      value={typesOptions.find((type) => type.value === defaultValue)}
      styles={{
        control: (baseStyles, _state) => ({
          ...baseStyles,
          borderWidth: 0,
        }),
        indicatorSeparator: () => ({ display: 'none' }),
      }}
    />
  )
}